import { useRef } from "react";
import { Camera, Upload, X } from "lucide-react";

const MAX_MB = 25;

/** Ask page attachments: camera shortcut (phones open the camera directly) + file picker + thumbnails. */
export function AskAttachments({ files, setFiles }) {
  const cam = useRef(null);
  const pick = useRef(null);
  const add = (list) => {
    const incoming = [...list].filter((f) => f.size <= MAX_MB * 1024 * 1024);
    setFiles((prev) => [...prev, ...incoming].slice(0, 6));
  };
  const remove = (i) => setFiles((prev) => prev.filter((_, idx) => idx !== i));

  return (
    <div data-testid="ask-attachments">
      <div className="dg-eyebrow mb-2 flex items-center gap-2"><Upload className="w-3 h-3" /> Photos or short video (optional, up to {MAX_MB}MB each)</div>
      <div className="grid grid-cols-2 sm:flex gap-2">
        <button type="button" onClick={() => cam.current?.click()} className="dg-btn-primary rounded-full px-4 py-2.5 min-h-[44px] text-sm flex items-center justify-center gap-2" data-testid="ask-camera-btn">
          <Camera className="w-4 h-4" /> Take a photo
        </button>
        <button type="button" onClick={() => pick.current?.click()} className="dg-btn-ghost rounded-full px-4 py-2.5 min-h-[44px] text-sm flex items-center justify-center gap-2" data-testid="ask-files-btn">
          <Upload className="w-4 h-4" /> Choose files
        </button>
      </div>
      <input ref={cam} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid="ask-camera-input" />
      <input ref={pick} type="file" multiple accept="image/*,video/*" className="hidden" onChange={(e) => { add(e.target.files); e.target.value = ""; }} data-testid="ask-files" />
      {files.length > 0 && (
        <ul className="mt-3 flex flex-wrap gap-2" data-testid="ask-attachment-list">
          {files.map((f, i) => (
            <li key={`${f.name}-${i}`} className="relative w-20 h-20 rounded-lg overflow-hidden border border-slate-700 bg-slate-900" data-testid={`ask-attachment-${i}`}>
              {f.type.startsWith("image/")
                ? <img src={URL.createObjectURL(f)} alt="" className="w-full h-full object-cover" onLoad={(e) => URL.revokeObjectURL(e.target.src)} />
                : <div className="w-full h-full grid place-items-center text-[10px] text-slate-400 px-1 text-center break-all">{f.name}</div>}
              <button type="button" onClick={() => remove(i)} className="absolute top-0.5 right-0.5 w-7 h-7 rounded-full bg-slate-950/80 text-white grid place-items-center" aria-label="Remove attachment" data-testid={`ask-attachment-remove-${i}`}><X className="w-3.5 h-3.5" /></button>
            </li>
          ))}
        </ul>
      )}
      {files.length > 0 && <div className="text-xs text-slate-400 mt-1 font-mono" data-testid="ask-attachment-count">{files.length} file{files.length === 1 ? "" : "s"} attached{files.length >= 6 ? " (max 6)" : ""}</div>}
    </div>
  );
}
